import { render } from "./Mosaic.vue?vue&type=template&id=6286453a&scoped=true"
import script from "./Mosaic.vue?vue&type=script&lang=js"
export * from "./Mosaic.vue?vue&type=script&lang=js"

import "./Mosaic.vue?vue&type=style&index=0&id=6286453a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6286453a"

export default script